import React, { useEffect, useState } from 'react';

import styles from './Table.module.scss';

interface Props {
  children?: any;

  destroy(): void;
}

const TableRow = ({ children, destroy }: Props) => {
  const [selected, setSelected] = useState(false);
  const setClicked = useState(false)[1];

  let className = styles.table__row;
  if (selected) className += ` ${styles.table__row__selected}`;

  useEffect(() => {
    const mouseDownHandler = () => {
      setClicked((clicked) => {
        if (!clicked) setSelected(false);
        return false;
      });
    };

    document.addEventListener('mousedown', mouseDownHandler);

    return () => {
      document.removeEventListener('mousedown', mouseDownHandler);
    };
  }, []);

  const keydownHandler = (event: React.KeyboardEvent) => {
    if (!selected) return;
    if (event.code === 'Delete') destroy();
  };

  return (
    <tr
      className={className}
      tabIndex={-1}
      onFocus={() => setSelected(true)}
      onKeyDown={keydownHandler}
      onMouseDown={() => setClicked(true)}
    >
      {children}
    </tr>
  );
};

TableRow.defaultProps = {
  children: [],
};

export default TableRow;
